import { render, staticRenderFns } from "./SupportTable.vue?vue&type=template&id=af93a9b8&scoped=true&"
import script from "./SupportTable.vue?vue&type=script&lang=js&"
export * from "./SupportTable.vue?vue&type=script&lang=js&"
import style0 from "./SupportTable.vue?vue&type=style&index=0&id=af93a9b8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af93a9b8",
  null
  
)

export default component.exports